import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';
import { copy } from 'angular';
import { CustomizerFilter, FilterOption } from '../models';
import { filterGroupsByFilters } from './filter-groups-by-filters';

export const predictFilterOptionsState = (groups: IProductWithAttributes[] = [], filters: CustomizerFilter[] = []): CustomizerFilter[] => {
  const predictedFilters: CustomizerFilter[] = [];
  let predictedGroups: IProductWithAttributes[];

  copy(filters, predictedFilters);
  for (const predictedFilter of predictedFilters) {
    if (!predictedFilter.available) {
      continue;
    }

    if (!Array.isArray(predictedFilter.options) || !predictedFilter.available) {
      continue;
    }

    const originalOptionChecked: FilterOption | undefined = predictedFilter.checkedOption;
    for (const predictedFilterOption of predictedFilter.options) {
      if (!predictedFilterOption.visible) {
        continue;
      }

      predictedFilterOption.checked = true;
      predictedGroups = filterGroupsByFilters(groups, predictedFilters);
      predictedFilterOption.disabled = predictedGroups.length === 0;
      predictedFilterOption.checked = false;
    }
    if (originalOptionChecked) {
      originalOptionChecked.checked = true;
    }
  }

  return predictedFilters;
};
